import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";
const BaseApiUrlSchema = z.union([
    z
        .enum(["api.oefr-kraken.systems", "api.oefr-kraken.energy"])
        .transform((v) => `https://${v}/v1/graphql/`),
    z
        .string()
        .refine((v) => v.startsWith("localhost"))
        .transform((v) => `http://${v.replace("localhost", "127.0.0.1")}/v1/graphql/`),
]);
export const env = createEnv({
    client: {
        NEXT_PUBLIC_CONSUMER_BASE_URL: z.url({ protocol: /^https$/ }),
        NEXT_PUBLIC_BASE_API_URL: BaseApiUrlSchema,
        NEXT_PUBLIC_STORYBLOK_ACCESS_TOKEN_FR: z.string().min(2),
        NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY: z.string().min(2),
        NEXT_PUBLIC_VERCEL_ENV: z.enum(["production", "preview", "development"]),
        NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA: z.string().optional(),
        NEXT_PUBLIC_DATADOG_CLIENT_TOKEN: z.string().min(2),
        NEXT_PUBLIC_DATADOG_APPLICATION_ID: z.string().min(2),
        NEXT_PUBLIC_DIDOMI_API_KEY: z.string().min(2),
        NEXT_PUBLIC_DARTY_BASE_URL: z.string().min(2),
        NEXT_PUBLIC_DARTY_HOST: z.string().min(2),
    },
    runtimeEnv: {
        NEXT_PUBLIC_CONSUMER_BASE_URL: process.env.NEXT_PUBLIC_CONSUMER_BASE_URL,
        NEXT_PUBLIC_BASE_API_URL: process.env.NEXT_PUBLIC_BASE_API_URL,
        NEXT_PUBLIC_STORYBLOK_ACCESS_TOKEN_FR: process.env.NEXT_PUBLIC_STORYBLOK_ACCESS_TOKEN_FR,
        NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY: process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY,
        NEXT_PUBLIC_VERCEL_ENV: process.env.NEXT_PUBLIC_VERCEL_ENV,
        NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
        NEXT_PUBLIC_DATADOG_CLIENT_TOKEN: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
        NEXT_PUBLIC_DATADOG_APPLICATION_ID: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID,
        NEXT_PUBLIC_DIDOMI_API_KEY: process.env.NEXT_PUBLIC_DIDOMI_API_KEY,
        NEXT_PUBLIC_DARTY_BASE_URL: process.env.NEXT_PUBLIC_DARTY_BASE_URL,
        NEXT_PUBLIC_DARTY_HOST: process.env.NEXT_PUBLIC_DARTY_HOST,
    },
});
